'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024 from "./presto.-Presto$.js";
var $p;
function $p_Lpresto_main$package$__container$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Element($thiz, container$lzy1$1) {
  if ((container$lzy1$1 === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  return (container$lzy1$1.jM ? container$lzy1$1.jN : container$lzy1$1.zo(document.getElementById("app")));
}
export { $p_Lpresto_main$package$__container$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Element as $p_Lpresto_main$package$__container$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Element };
function $p_Lpresto_main$package$__container$1__sr_LazyRef__Lorg_scalajs_dom_Element($thiz, container$lzy1$2) {
  return (container$lzy1$2.jM ? container$lzy1$2.jN : $p_Lpresto_main$package$__container$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Element($thiz, container$lzy1$2));
}
export { $p_Lpresto_main$package$__container$1__sr_LazyRef__Lorg_scalajs_dom_Element as $p_Lpresto_main$package$__container$1__sr_LazyRef__Lorg_scalajs_dom_Element };
/** @constructor */
function $c_Lpresto_main$package$() {
}
export { $c_Lpresto_main$package$ as $c_Lpresto_main$package$ };
$p = $c_Lpresto_main$package$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_main$package$;
/** @constructor */
function $h_Lpresto_main$package$() {
}
export { $h_Lpresto_main$package$ as $h_Lpresto_main$package$ };
$h_Lpresto_main$package$.prototype = $p;
$p.cKs = (function() {
  var container$lzy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sr_LazyRef();
  var this$3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a;
  var container = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction0(((container$lzy1$2) => (() => $p_Lpresto_main$package$__container$1__sr_LazyRef__Lorg_scalajs_dom_Element(this, container$lzy1$2)))(container$lzy1));
  var rootNode = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction0((() => $j_presto$002e$002dPresto$0024.$m_Lpresto_Presto$().cNW()));
  var p = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_keys_EventProcessor$().W(this$3.a58.cLG(), false, false);
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_CollectStream($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_web_DomEventStream$().abG(document, p.h3.lx, p.k3), p.k2), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$2) => {
    new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_nodes_RootNode(container.aq(), rootNode.aq());
  })), this$3.cvS());
});
var $d_Lpresto_main$package$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_main$package$, "presto.main$package$", ({
  VT: 1
}));
export { $d_Lpresto_main$package$ as $d_Lpresto_main$package$ };
var $n_Lpresto_main$package$;
function $m_Lpresto_main$package$() {
  if ((!$n_Lpresto_main$package$)) {
    $n_Lpresto_main$package$ = new $c_Lpresto_main$package$();
  }
  return $n_Lpresto_main$package$;
}
export { $m_Lpresto_main$package$ as $m_Lpresto_main$package$ };
//# sourceMappingURL=presto.main$package$.js.map
